import React from 'react';
import { Grid } from '@mui/material';

const SuccessLayout = ({ children }) => {
  const [leftContent, rightContent] = React.Children.toArray(children);

  return (
    <>
      <Grid
        container
        rowSpacing={{ xs: 2, md: 4 }}
        columnSpacing={{ xs: 0, md: 4 }}
        sx={{
          mt: { xs: '10px', md: 0 },
          width: '100%',
          px: { xs: 2, md: 2, lg: 2 },
          pb: { xs: 2, md: 4 },
        }}
      >
        {rightContent && (
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              order: { xs: 1, md: 2 },
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {rightContent}
          </Grid>
        )}

        {leftContent && (
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              order: { xs: 2, md: 1 },
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {leftContent}
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SuccessLayout;
